<!--  -->
<template>
	<div class="drawer-wrapper">
		<el-drawer title="卡点定价" :wrapperClosable="true" :visible.sync="AddWorksFlag" size="55%"
			:before-close="handleCloseDuanju">
			<div class="demo-drawer__content" style="margin: auto; width: 90%">
			<el-form :model="AddqueryParams"  :rules="rules" size="medium" label-width="100px" class="mt35"
              ref="ruleForm">
			  <el-form-item label="书籍ID：" prop="book_id">
                <el-input v-model="AddqueryParams.book_id" :disabled="true"  placeholder="书籍ID" clearable></el-input>
              </el-form-item>
			  <el-form-item label="单章价格：" prop="o_episode_price">
                <el-input v-model="AddqueryParams.o_episode_price" oninput="value=value.replace(/^0|[^\d]/g,'')"  placeholder="请输入单章价格：" clearable></el-input>
              </el-form-item>
			  <el-form-item label="免费章节：" prop="o_free_episode">
                <el-input v-model="AddqueryParams.o_free_episode" oninput="value=value.replace(/^0|[^\d]/g,'')" maxlength='9' placeholder="请输入免费章节" clearable></el-input>
              </el-form-item>
			  </el-form>
			  <div class="demo-drawer__footer">
            <el-button @click="handleCloseDuanju">取 消</el-button>
            <el-button type="primary" @click="AddSub">确 定</el-button>
          </div>
			  </div>
		</el-drawer>
		<!-- 小说阅读弹窗 -->
		 
	</div>
</template>

<script>
import { playletAPI } from '@/api/popularize/playletList';
import { RechargeAPI } from '@/api/popularize/Recharge';
import { processErrors } from '@/utils/errorHandler';
import { useLoginApi } from '@/api/login';
export default {
	props: ['AddWorksFlag', 'tableObj'],
	components: {},
	data() {
		return {
			AddqueryParams:{
				book_id:'',
				o_episode_price:'',
				o_free_episode:'',
			},
			readinfo:'',
			readName:'',
			dialogVisible:false,
			formLabelWidth: "120px",
			switch_btn: 0,
			tabList: [],
			total: 0,
			Recharge: [{ id: 0, value: '默认' }],
			RechargeRule: [{ id: 0, value: '默认' }],
			Placement: [],
			prefix: [],
			movieID: '',
			queryParams: {
				pageSize: 999,
				pageNo: 1,
				id: this.tableObj.id,
			},
			queryParamsLook: {
				pageNo: 1,
				pageSize: 10,
				movie_id: 0
			},
			tableData: [],
			total: 0,
			multipleSelection: [],
			innerVisible: false,
			LookVisible: false,
			addFrom: {
				id: '',
				novel_id: '',
				platform_type: '',
				recharge_template_id: 0,
				ad_id: 0,
				media: '',
				status: 1,
				channel_num: '',
				owner: '',
				channel_name: '',
				o_episode_price: '',
				o_free_episode: '',
				channel_prefix: '',
				movie_name: '',
				chapters_id: '',
				chapters_name: '',
				chapters_idx: '',
			},
			chapter: {
				chapter_priceone: '',
				chapter_pricetwo: '',
				free_chapteroneone: '',
				free_chaptertwo: '',
			},
			channelprefixList: [],
			appidList: [],
			topObj: {},
			rules: {
				book_id: [
					{ required: true, message: '请输入活动名称', trigger: 'blur' }
				],
				o_episode_price: [
					{ required: true, message: '请输入单集价格', trigger: 'blur' },
					{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确的格式,可保留两位小数' }
				],
				o_free_episode: [
					{ required: true, message: '请输入免费集数', trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							// 如果没有输入值，直接调用callback，不做任何验证
							if (value === null || value === '') {
								callback();
							}  else {
								callback(); // 验证通过
							}
						},
						trigger: 'blur',
					},
				],
			},
			platformList: [],
		};
	},

	methods: {
		getPrice(item){
			let api = playletAPI();
			let params = {
				book_id:item.id
			}
			api.getchapterprice(params).then((res) => {
				if (res.code == 0) {
					this.AddqueryParams={
						book_id:item.id,
						o_episode_price:res.data.o_episode_price,
						o_free_episode:res.data.o_free_episode,
					}
					
				} else {
					processErrors(res);
				}
			});
		},
		handleClose1(){
			this.dialogVisible = false
		},
		readBook(item){
			console.log(item,'查看信息')
			
			let api = playletAPI();
			let params = {
				bookId:item.book_id,
				chapterId:item.chapter_id
			}
			api.redbook(params).then((res) => {
				if (res.code == 0) {
					this.dialogVisible = true
					console.log('数据信息',res)
					this.readinfo = res.data.content
					this.readName = res.data.name
				} else {
					processErrors(res);
				}
			});
		},
		selectHand(id) {
			this.addFrom.recharge_template_id = id
			this.LookVisible = false
		},
		Preview(row) {
		},
		Look() {
			this.LookVisible = true;
			this.getListLook();
		},
		getListLook() {
			let api = playletAPI();

			// let params={
			// 	movie_id:0,
			// 	pageNo: 1,
			// 	pageSize: 10,
			// }
			api.RechargeList(this.queryParamsLook).then((res) => {
				if (res.code == 0) {
					this.tableData = res.data.data;
					this.total = res.data.totalCount;
				} else {
					processErrors(res);
				}
			});
		},
		getUserinfo() {
			const api = useLoginApi();
			api.getUserinfo().then((res) => {
				this.switch_btn = res.data.episode_switch;
			});
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		handleCloseDuanju() {
			this.$emit('NoneDlog');
		},
		AddSub(){
			let api = playletAPI();
			api.setchapterprice(this.AddqueryParams).then((res) => {
				if (res.code == 0) {
					this.$emit('AddOk');
				} else {
					processErrors(res);
				}
			});
			
		},
		handleCloseLook() {
			this.LookVisible = false;
		},
		getList() {
			let api = playletAPI();
			api.VideoList(this.queryParams.id).then((res) => {
				if (res.code == 0) {
					this.tabList = res.data;
				} else {
					processErrors(res);
				}
			});
		},
		// 开启渠道弹窗
		addFlag(row) {
			console.log(row,'传过来的值')
			this.addFrom.book_id = row.book_id;
			this.addFrom.book_name = this.tabList.book.real_name;
			this.addFrom.chapter_id = row.chapter_id;
			this.addFrom.chapter_name = row.name;
			this.addFrom.chapter_idx = row.sequence;
			this.book_id = row.book_id;
			this.innerVisible = true;
			this.SelectRecharge();
			this.SelectPlatform();
			// this.SelectRechargeRule()
			this.addFrom.platform_type = 2;
			this.SelectPlacement();
			let api = playletAPI();
			// api.freepoint(row.novel_id).then((res) => {
			// 	if (res.code == 0) {
			// 		this.chapter.chapter_priceone = res.data.chapter_price_range[0];
			// 		this.chapter.chapter_pricetwo = res.data.chapter_price_range[1];
			// 		this.chapter.free_chapteroneone = res.data.free_chapter_range[0];
			// 		this.chapter.free_chaptertwo = res.data.free_chapter_range[1];
			// 	} else {
			// 		processErrors(res);
			// 	}
			// });
		},

		/**
		 * 获取投放平台列表
		 * @constructor
		 */
		SelectPlatform() {
			let api = playletAPI();
			api.PlatformList().then((res) => {
				if (res.code == 0) {
					this.platformList = Object.entries(res.data).map(([id, name]) => ({
						id: parseInt(id),
						name,
					}));
				} else {
					processErrors(res);
				}
			});
		},

		// 充值模版select数据
		SelectRecharge() {
			let api = playletAPI();
			let params = {
				// movie_id:this.movieID,
				pageNo: 1,
				pageSize: 9999
			}
			api.RechargeList(params).then((res) => {
				if (res.code == 0) {
					// if (Array.isArray(res.data) && res.data.length === 0) {
					//     let obj = {
					//         value: "默认",
					//         id: "aa"
					//     }
					//     this.addFrom.recharge_template_id='aa'
					//     this.Recharge.push(obj)
					// } else {
					this.Recharge = res.data.data.map((item) => {
						return {
							value: 'ID=' + item.id + '，标题=' + item.name + '，创建人=' + item.admin_type_text,
							id: item.id,
						};
					});

					let objs = {
						value: '默认充值模版',
						id: 0,
					};
					this.Recharge.unshift(objs);
					// }
				} else {
					processErrors(res);
				}
			});
		},
		SelectRechargeRule() {
			let api = playletAPI();
			api.Adselect().then((res) => {
				this.RechargeRule = res.data;
				let objs = {
					value: '默认配置',
					id: 0,
				};
				this.RechargeRule.unshift(objs);
			});
		},
		// 切换小说平台时
		async changeSe() {
			// 投放媒体
			await this.SelectPlacement();
		},
		// 切换投放媒体时
		changeMedia(e) {
			let api = playletAPI();
			api.Adselect(e).then((res) => {
				this.RechargeRule = res.data;
				let objs = {
					value: '默认配置',
					id: 0,
				};
				this.RechargeRule.unshift(objs);
				const modifiedArray = this.RechargeRule.map((item) => ({
					id: item.id,
					value: item.value || item.title, // 使用 value，如果不存在则使用 title
				}));
				this.RechargeRule = modifiedArray;
			});
			this.addFrom.channel_prefix = this.findChannelByPrefix(this.addFrom.media, this.channelprefixList);
		},
		// 投放媒体
		SelectPlacement() {
			let api = playletAPI();
			api.PlacementList(this.addFrom.platform_type).then(async (res) => {
				if (res.code == 0) {
					this.Placement = Object.keys(res.data).map((key) => {
						return {
							name: res.data[key],
							key: key,
						};
					});
					let api = playletAPI();
					api.Adselect(this.Placement[0].key).then((res) => {
						this.RechargeRule = res.data;
						let objs = {
							value: '默认配置',
							id: 0,
						};
						this.RechargeRule.unshift(objs);
						const modifiedArray = this.RechargeRule.map((item) => ({
							id: item.id,
							value: item.value || item.title, // 使用 value，如果不存在则使用 title
						}));
						this.RechargeRule = modifiedArray;
					});

					this.addFrom.media = this.Placement[0].key;
					api.prefixList(this.addFrom.platform_type ? this.addFrom.platform_type : 1).then((res) => {
						if (res.code == 0) {
							this.channelprefixList = res.data;
							// 匹配前缀
							this.addFrom.channel_prefix = this.findChannelByPrefix(this.addFrom.media, this.channelprefixList);
						}
					});
				} else {
					processErrors(res);
				}
			});
		},
		// 媒体前缀
		Selectprefix() {
			let api = playletAPI();
			api.prefixList(this.addFrom.platform_type ? this.addFrom.platform_type : 1).then((res) => {
				if (res.code == 0) {
					this.channelprefixList = res.data;
				} else {
					processErrors(res);
				}
			});
		},
		findChannelByPrefix(prefix, list) {
			// 遍历列表
			for (let item of list) {
				// 获取 `-` 前的两位字符
				const channelPrefixStr = item.channel_prefix.split('-')[0];
				const channelPrefix = channelPrefixStr.substring(channelPrefixStr.length - 2);
				// 检查 channel_prefix 是否与给定的前缀相等
				if (channelPrefix === prefix) {
					return item.channel_prefix;
				}
			}
			// 如果没有找到匹配项，则返回 null
			return null;
		},
		handleClose() {
			(this.addFrom = {
				movie_id: '',
				platform_type: '',
				recharge_template_id: 0,
				media: '',
				status: 1,
				ad_id: 0,
				channel_num: '',
				owner: '',
				channel_name: '',
				channel_prefix: '',
				o_episode_price: '',
				o_free_episode: '',
			}),
				(this.Recharge = []);
			this.$refs['ruleForm'].resetFields();
			this.innerVisible = false;
		},
		// 关闭渠道弹窗
		AddNone() {
			(this.addFrom = {
				movie_id: '',
				platform_type: '',
				recharge_template_id: 0,
				media: '',
				status: '',
				ad_id: 0,
				channel_num: '',
				owner: '',
				channel_name: '',
				channel_prefix: '',
				o_episode_price: '',
				o_free_episode: '',
			}),
				(this.Recharge = []);
			this.$refs['ruleForm'].resetFields();
			this.innerVisible = false;
		},
		// 新增渠道
		addPush() {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					let api = playletAPI();

					api.playletAdded(this.addFrom).then((res) => {
						if (res.code == 0) {
							this.$message({
								message: '创建成功',
								type: 'success',
							});
							this.$router.push('/popularize/channelNumber');
							this.innerVisible = false;
						} else {
							processErrors(res);
							this.innerVisible = false;
						}
					});
				} else {
					return false;
				}
			});
		},
	},
	created() {
		// this.Selectprefix();
		// this.getUserinfo();
		console.log(this.tableObj,'卡点传值')
	},
	mounted() {
		// this.getList();
		// let api = playletAPI();
		// console.log(this.tableObj,'传过来的值')
		this.getPrice(this.tableObj)
		
	},
};
</script>
<style lang="scss" scoped>
.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}
.demo-drawer__content {
  height: calc(100% - 80px);
  /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto;
  /* 添加垂直滚动条 */
  overflow-x: hidden;
}
.Box {
	& ::v-deep el-card__body {
		padding: 0 !important;
	}
}

.btnAdDanjuitem {
	padding: 0;
	display: flex;
	margin-left: 16px;
	background-image: url('../../../../assets/微信图片_20240910174026.png');
	background-size: cover;
	// /* 使背景图覆盖整个容器 */
	background-position: center;
	// /* 背景图居中对齐 */
	background-repeat: no-repeat;
	/* 背景图不重复 */
	// height: 100vh;
	/* 高度覆盖视口高度 */
	width: 314px;
	margin-bottom: 20px;
	height: 70px;
	border: #ccc 1px solid;
	border-radius: 10px;
	position: relative;
	overflow: hidden;

	.left {
		// display: flex;
		// flex-direction: column;
		width: 230px;
		// height: 80px;
		// line-height: 70px;
		text-align: center;
		// line-height: 30px;
	}

	.right {
		width: 100px;
		line-height: 70px;
		text-align: center;
		color: #e44663;

		span {
			font-size: 18px;
			color: #e44663;
			text-align: center;
		}
	}

	.right_jiao {
		height: 10px;
		position: absolute;
		right: 0px;

		top: -20px;
		// width: 40px;
		font-size: 11px;

		.jiao {
			color: #fff;
			margin-top: 9px;
			padding: 2px 10px 2px 16px;
			background-color: #ed6e33;
			// width: 80px;
			text-align: center;
			height: 30px;
			border-bottom-left-radius: 20px;
		}
	}
}

.PreviewBox {
	width: 800px;
	// height: 300px;
	display: flex;
	// justify-content: space-around;
	flex-wrap: wrap;
	padding: 4px;

	.white-background {
		background-color: #fff;
	}

	.black-background {

		background-color: white;
		background-image: url('../../../../assets/zhuan.png');
		background-size: cover;
		/* 使背景图覆盖整个容器 */
		background-position: center;
		/* 背景图居中对齐 */
		background-repeat: no-repeat;
		//  背景图不重复
		height: 100vh;
	}

	.btnAd {
		width: 150px;
		height: 110px;
		// border: #ccc 1px solid;
		border-radius: 10px;
		// margin-top: 10px;
		padding: 0px;
		margin-left: 16px;

		.btnAd_wai {
			border-radius: 10px;
			width: 150px;
			height: 100px;

			.price {
				height: 20px;
				font-size: 15px;
				line-height: 60px;
				text-align: center;
				font-size: 18px;
				font-weight: bold;
			}

			.bi {
				font-size: 10px;
				margin-top: 23px;
				// margin-top: 6px;
				text-align: center;
			}

			.dingBtn {
				position: absolute;
				top: -43px;
				right: 0px;
				height: 20px;
				// width: 40px;
				background-color: antiquewhite;
				line-height: 18px;
				text-align: center;
				padding: 2px 6px;
				background-color: #1890ff;
				color: #fff;
				border: 1px solid #ed6e33;
				border-top-right-radius: 7px;
				border-bottom-left-radius: 10px;
				font-size: 11px;
			}

			.song {
				margin: auto;
				width: 100%;
				line-height: 29px;
				text-align: center;
				font-size: 13px;
				margin-top: 15px;
				background-color: #1890ff;
				// border-radius: 10px;
				color: #fff;
				border-bottom-left-radius: 10px;
				border-bottom-right-radius: 10px;
			}
		}
	}
}

.top_box {
	width: 100%;
	height: 200px;
	display: flex;

	.tioBox_left {
		width: 30%;
		height: 200px;
		display: flex;
		align-items: center;
		justify-content: center;

		.left_img {
			width: 150px;
			height: 150px;
		}
	}

	.tioBox_right {
		width: 70%;
		height: 200px;
		padding: 30px 0 20px 20px;

		.title_name {
			font-size: 14px;
			margin-top: 5px;
		}
	}
}

.center-content {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
}

.center-content .el-col {
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.demo-drawer__content {
	overflow-y: auto;
	/* 添加垂直滚动条 */
	margin: 0 20px;
	overflow-x: hidden;
}

.form-wrapper {
	padding-bottom: 80px;
	/* 给表单内容添加底部间距,留出按钮区域 */
}

::v-deep .el-drawer__close-btn {
	font-size: 30px;
	font-weight: bold;
}
</style>
